<template>
  <div>
    <navbar 
      ref="navbar"
      position="fixed"
      menu-classes="ml-auto">
      <template>
        <router-link 
          class="navbar-brand" 
          to="/">
          <img 
            src="img/logo.jpg"
            height="56">
        </router-link>
      </template>
      <template slot="navbar-menu">
        <drop-down
          tag="li" 
          title="Airports" 
          icon="bx bxs-plane-alt mr-1" 
          class="nav-item">
          <nav-link
            v-for="(item, index) of airports"
            :key="index"
            :to="`/offers?airportCode=${item.code}`"
            class="dropdown-item">
            {{ item.city }}({{ item.code }})
          </nav-link>
        </drop-down>
        <li class="nav-item">
          <router-link 
            v-if="showReserve"
            class="nav-link" 
            to="/offers">
            <i class="bx bxs-car mr-1"/>
            <p>Reserve Now</p>
          </router-link>
        </li>
        <drop-down
          tag="li" 
          title="Policies" 
          icon="bx bx bx-shield mr-1" 
          class="nav-item">
          <nav-link
            to="/privacy-policy"
            class="dropdown-item">
            <i class="bx bx-shield mr-1"></i>
            Privacy Policy
          </nav-link>
          <nav-link
            to="/cancelation-policy"
            class="dropdown-item">
            <i class="bx bx-shield-x mr-1"></i>
            Cancelation Policy
          </nav-link>
          <nav-link
            to="/terms-of-service"
            class="dropdown-item">
            <i class="bx bxs-file mr-1"></i>
            Terms of Service
          </nav-link>
        </drop-down>
        <li class="nav-item">
          <router-link 
            class="nav-link" 
            to="/faq">
            <i class="bx bx-message-square"></i> 
            <p>FAQ</p>
          </router-link>
        </li>
        <li 
          v-if="!accessToken" 
          class="nav-item">
          <a 
            class="nav-link" 
            href="#"
            @click.prevent="toggleLoginModal()">
            <i class="bx bx-log-in-circle mr-1"></i>
            <p>Login</p>
          </a>
        </li>
        <drop-down
          v-if="accessToken"  
          tag="li" 
          title="My Accounts" 
          icon="bx bx-user-circle mr-1" 
          class="nav-item">
          <nav-link 
            class="dropdown-item" 
            to="/history">
            <i class="bx bx-history"/> My Reservations
          </nav-link>
          <nav-link 
            class="dropdown-item" 
            to="/settings">
            <i class="bx bx-cog"/> Settings
          </nav-link>
          <a 
            class="dropdown-item" 
            href="#"
            @click.prevent="logout">
            <i class="bx bx-log-out-circle"/> Logout
          </a>
        </drop-down>
      </template>
    </navbar>
  </div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex';
  import { DropDown, FormGroupInput, NavbarToggleButton, Navbar, NavLink } from '@/components';
  import axios from "axios";

  export default {
    components: {
      DropDown,
      [FormGroupInput.name]: FormGroupInput,
      Navbar,
      NavbarToggleButton,
      NavLink
    },
    data() {
      return {
        fontSize: 'inherit',
        showReserve: false,
        airports: [],
        directReserveList: [
          '/history',
          '/settings',
          '/faq',
          '/privacy-policy',
          '/terms-of-service'
        ]
      }
    },
    computed: {
      ...mapState([
        'accessToken',
        'options'
      ])
    },
    watch: {
      $route(to, from) {         
        if (this.directReserveList.includes(to.name)) {
          this.showReserve = true;
        } else {
          this.showReserve = false;
        }
      }
    },
    created() {
      this.getAirports();
    },
    methods: {
      ...mapMutations([
        'setAccessToken',
        'setMember',
        'setLoginModal'
      ]),
      toggleLoginModal() {
        this.$refs.navbar.toggle();
        this.setLoginModal(true);
      },
      logout() {
        localStorage.clear();
        this.setAccessToken(null);
        this.setMember({});
        this.$router.push('/');
      },
      getAirports() {
        axios.get("airport").then((res) => {
          console.log("airports", res);
          this.airports = res.data;
        }).catch(() => {
          this.setLoading(false);
        });
      },
      viewAirport(item) {
        console.log('item', item);
        this.$router.replace({
          name: "/offers",
          query: {
            name: item.name,
            airportCode: item.code,
            lat: item.coordinate.coordinates[1],
            lng: item.coordinate.coordinates[0],
          },
        });
      },
    }
  }
</script>

<style scoped lang='scss'>
  .navbar-brand {
    display: flex;
    align-items: center;
    color: #555357 !important;
    font-weight: 700;
    font-family: 'Montserrat';
    font-size: 1.25em !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  ::v-deep .nav-link,
  ::v-deep .dropdown-item {
    i {
      position: relative;
      top: 4px;
      font-size: 20px;
    }
  }
</style>
